<template>
  <div class="home-view"></div>
</template>

<script>
export default {
  name: 'home-view',
};
</script>



// WEBPACK FOOTER //
// HomeView.vue?14e07429